const metadataQueryKeys = {
    tables: ["metadata", "sys_tables"] as const,
    columns: ["metadata", "sys_columns"] as const,
    currencies: ["metadata", "sys_currencies"] as const,
    property: (name: string) => ["metadata", "sys_properties", name] as const,
};

export default metadataQueryKeys;
